import moment from 'moment';

import { getPrices as getActivityPrices } from 'utils/accommodations-and-activities/prepareReceivedActivityData';
import { getPrices as getAccommodationPrices } from 'utils/accommodations-and-activities/prepareReceivedAccommodationData';
import { getParticipants as getActivityParticipants } from 'utils/book-activity/prepareParticipants';
import { getParticipants as getAccommodationParticipants } from 'utils/book-accommodation/prepareParticipants';
import {
  getReceivedAddOns,
  getReceivedMandatoryFees,
  getReceivedParticipant,
  getReceivedSchedule
} from 'utils/book-accommodation-and-activity/prepareReceivedDataMethods';

const FIXED_PRICES = 'pricesFixedForm';
const CATEGORY_PRICES = 'pricesCategoryForm';
const DAILY_PRICES = 'pricesDailyForm';
const FUTURE_PRICES = 'futurePricesForm';

const getReceivedBookedAccommodationData = data => {
  const payment = data.payments[0];
  const currency = payment.currency.currency;

  const pricesObj = getAccommodationPrices(data.accommodation);
  let accommodation = {
    ...data.accommodation,
    ...pricesObj
  };

  // Determine base prices type from the available raw data
  let basePricesType = FIXED_PRICES;

  if (accommodation.prices[0]?.participant?.participant) {
    basePricesType = CATEGORY_PRICES;
  } else if (accommodation.prices[0]?.day) {
    basePricesType = DAILY_PRICES;
  }

  accommodation['basePricesType'] = basePricesType;

  if (accommodation.futurePrices?.[0]?.ratePlanPrices) {
    accommodation['pricesType'] = FUTURE_PRICES;
  } else {
    accommodation['pricesType'] = basePricesType;
  }

  const dates = {
    startDate: moment(data.fromDate, 'YYYY-MM-DD'),
    endDate: moment(data.toDate, 'YYYY-MM-DD')
  };

  const accommodationParticipants = getAccommodationParticipants(
    accommodation,
    currency,
    null,
    dates
  );

  return {
    id: parseInt(data.id),
    accommodationId: parseInt(data.accommodation.id),
    firstName: data.guestFirstName,
    lastName: data.guestLastName,
    phone: data.guestPhoneNumber,
    email: data.guestEmail,
    platform: data.platform,
    pay: {
      'Pay on arrival': true
    },
    dates: dates,
    maxParticipants: data.accommodation.guestsNumber,
    currency: currency,
    paymentId: parseInt(payment.id),
    addOns: getReceivedAddOns(data.bookedAddOns),
    mandatoryFees: getReceivedMandatoryFees(data.bookedMandatoryFees),
    participants: getReceivedParticipant(
      data.guests,
      currency,
      accommodationParticipants
    ),
    activities: _getReceivedRelatedActivities(
      data.relatedActivitiesBookings,
      currency
    )
  };
};

const _getReceivedRelatedActivities = (relatedActivitiesBookings, currency) => {
  return relatedActivitiesBookings.map(item => {
    const payment = item.payments[0];
    const startingDate = item.startingDate
      ? moment(item.startingDate, 'YYYY-MM-DD')
      : null;
    const endingDate = item.endingDate
      ? moment(item.endingDate, 'YYYY-MM-DD')
      : null;

    const pricesObj = getActivityPrices(item.activity);
    const activity = {
      ...item.activity,
      ...pricesObj
    };
    const participantData = {
      values: { currency: currency, startingDate: startingDate }
    };

    const activityParticipants = getActivityParticipants(
      activity,
      participantData,
      () => {},
      false
    );

    const norwegianFields = {};
    if (item.activity.titleNo) {
      norwegianFields.title = item.activity.titleNo;
    }

    const dates = {};

    if (startingDate && endingDate) {
      dates.multiDates = {
        startDate: startingDate,
        endDate: endingDate
      };
      dates.startingDate = null;
    } else {
      dates.startingDate = startingDate;
    }

    return {
      id: parseInt(item.id),
      activity: parseInt(item.activity.id),
      title: item.activity.title,
      Norwegian: norwegianFields,
      platform: item.platform,
      currency: currency,
      paymentId: parseInt(payment.id),
      addOns: getReceivedAddOns(item.bookedAddOns),
      mandatoryFees:getReceivedMandatoryFees(item.bookedMandatoryFees),
      participants: getReceivedParticipant(
        item.guests,
        currency,
        activityParticipants
      ),
      ...getReceivedSchedule(item.schedule),
      ...dates
    };
  });
};

export { getReceivedBookedAccommodationData };
